export default "__VITE_ASSET__B0bwzQT3__"